import { PageHeading, TableRegion } from '../components/ui';
import { useSnapshot } from '../context';
import { describeEvents } from '../lib/log';

function formatTime(iso: string): string {
  const d = new Date(iso);
  return Number.isNaN(d.getTime())
    ? iso
    : d.toLocaleString(undefined, { dateStyle: 'short', timeStyle: 'medium' });
}

export function LogTab() {
  const { events } = useSnapshot();
  const lines = describeEvents(events).reverse();
  return (
    <section>
      <PageHeading>Event log</PageHeading>
      <p className="hint">
        Every change to the tournament, newest first. The tournament is rebuilt from this log; Undo
        removes the newest entry.
      </p>
      <TableRegion label="Event log">
        <table className="data-table log">
          <thead>
            <tr>
              <th scope="col" className="num">
                #
              </th>
              <th scope="col">When</th>
              <th scope="col">By</th>
              <th scope="col">Change</th>
            </tr>
          </thead>
          <tbody>
            {lines.map((l) => (
              <tr key={l.seq}>
                <td className="num">{l.seq}</td>
                <td>
                  <time dateTime={l.at}>{formatTime(l.at)}</time>
                </td>
                <td>{l.actor}</td>
                <td>{l.text}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </TableRegion>
    </section>
  );
}
